import React, {useRef, useState, forwardRef} from 'react'
import DatePicker from 'react-datepicker';
import moment from 'moment'
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

export function DatePickerField (props) {
    let {
        name,
        type = 'text',
        onChange = () => { },
        onBlur = () => { },
        hasError = false,
        feedback,
        touched,
        errors,
        mandatory = false,
        required = false,
        value,
        onFocus,
        placeholder,
        disabled = false,
        ...rest
    } = props
    const label = props.label || name || ''
    value = (value === '' || value === null || typeof value === "undefined") ? null : new Date(value)
    mandatory = mandatory ? mandatory : required;

    
    if (touched && errors && !hasError) {
        hasError = true
        if (!feedback) {
            feedback = errors
        }
    }
    
	//Ref needed for custom input
	const refCustomInput = useRef();
  const inputLabel = React.useRef(null);

	//State hooks
	const [stateHasFocus, setStateHasFocus] = useState(false); //Initial value

	//Custom input
	const CustomInput = forwardRef((props, ref) => {
		const {autoFocus, ...remaining} = props;

		return <input type="text" ref={ref} autoFocus={stateHasFocus} {...remaining} />;
	});

    return (<>
    
    <FormControl fullWidth variant="outlined" className="panel-header" >
        <InputLabel
          shrink
          ref={inputLabel}
          htmlFor="outlined-always-notched"
        >
          {label} {mandatory && <span>&nbsp;*</span>}
        </InputLabel>
        {/* <label>{label}</label>{mandatory && <span className="text-danger">&nbsp;*</span>} */}
        <div style={{padding:"5px"}} className={"form-group form-focus" + (value || value === 0 ? ' focused' : '')}>
            
            <DatePicker
            disabled={disabled}
            customInput={<CustomInput ref={refCustomInput} />}
                className={'form-control'}
                  selected={ value }
                  onChange={val => {
                      if (val && (new Date("9999-12-31") >= val)) {
                        const date = val ? moment(val).format('YYYY-MM-DD') : ''
                        onChange(String(date))
                      }
                  }}
                  onFocus={evt => {
                      setStateHasFocus(true);
      
                      //Notify parent
                      if (onFocus) {
                          onFocus.call(this, evt);
                      }
                  }}
                  onBlur={evt => {
                      setStateHasFocus(false);
      
                      //Notify parent
                      if (onBlur) {
                          onBlur.call(this, evt);
                      }
                  }}
                  name={name}
                  dateFormat="dd/MM/yyyy"
                  id="outlined-always-notched"
                  {...rest}
                  showMonthDropdown
                  showYearDropdown
                  />
                  
            {!value && <label className="focus-label">dd/mm/yyyy</label>}
            {hasError && feedback && (
                <div style={{ margin: 0 }} className="invalid-feedback d-block">{feedback}</div>
            )}
        </div>
      </FormControl>
    </>)
}